<template>
	<div>
		<v-select placeholder="---Selectionnez une agence---" @change="$emit('input', model)"  @input="$emit('input', model)" v-model="model" 
				 :id="id" :name="name" class="style-chooser" :get-option-label="(option)=>option.Name +' ('+ option.Phone+')'" label="Name" :options="list" 
				 :selected="selected(model)" :reduce="model => model.AD_Org_ID" :disabled="disabled"> 
				<template slot="option" slot-scope="option">
					{{ option.Name }} ({{ option.Prefix }}-{{ option.AD_Org_ID }})
					<br />
					{{ option.City }} ({{ option.street }})
					<br>
					{{ option.Phone }}
				</template>
				<div slot="no-options">Désolé, aucune agence disponible</div>
		</v-select>
		<slot name="after"></slot>
	</div>
</template>
<script>
	export default {
		props: ['list', 'fieldValue', 'fieldText', 'id', 'name', 'className', 'isPending', 'value', 'disabled',
			'groupClassName'],
		data() {
			return {
				model: '',
			}
		},
		mounted() {
			this.model = '';
		},
		watch: {
			value(before, after) {
				this.model = this.$props.value;
			}
		},
		methods: {
			selected(val) {
				this.$emit('payeur', this.model)
				return this.value == val;
			}
		}
	}
</script>

<style>

  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    background: #fff;
    border: 1px solid grey; 
	color: #394066;
	 width: 100%;
    /* text-transform: lowercase; */
    font-variant: small-caps;
  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/select-group-search.vue